<footer class="app-footer" aria-label="Rodapé da aplicação">
  <div class="footer-accent" aria-hidden="true"></div>

  <div class="footer-inner">
    <div class="footer-main">
      <div class="footer-brand">
        <span class="footer-product">Controle de Bilhetagem</span>
        <span class="footer-tagline">Gestão de excedentes e consumo</span>
      </div>

      <p class="footer-meta">
        <span class="footer-copy">© {{ currentYear }} Vetor IT</span>
        <span class="footer-dot" aria-hidden="true">·</span>
        <span>Licenciado para <strong>Avalara</strong></span>
        <span class="footer-dot" aria-hidden="true">·</span>
        <a routerLink="/release-notes" class="footer-version" title="Ver Release Notes">
          v{{ appVersion }}
        </a>
      </p>
    </div>

    <div class="footer-partner" aria-label="Parceiro tecnológico">
      <span class="footer-partner-label">Parceria</span>
      <img
        src="img/avalara-logo-1.png"
        alt="Avalara"
        class="footer-logo"
        width="88"
        height="28"
        loading="lazy"
      />
    </div>
  </div>
</footer>
